import { useCallback, useEffect, useState } from "react";

const LS_KEY = "dfo.compactTables";

function readSaved(): boolean {
  try {
    return window.localStorage.getItem(LS_KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * Table density toggle. Flips body.dag-compact-tables, which the scoped CSS uses
 * to tighten the data tables (Accounting statements, invoice lists). Remembered
 * across sessions. Matches the onboarding cluster's comfortable/compact control.
 */
export function useDensity(): { compact: boolean; toggle: () => void } {
  const [compact, setCompact] = useState<boolean>(readSaved);

  const toggle = useCallback(() => setCompact((prev) => !prev), []);

  useEffect(() => {
    document.body.classList.toggle("dag-compact-tables", compact);
    try {
      window.localStorage.setItem(LS_KEY, compact ? "1" : "0");
    } catch {
      /* storage disabled — ignore */
    }
    return () => document.body.classList.remove("dag-compact-tables");
  }, [compact]);

  return { compact, toggle };
}
